import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile, useTranslation } from '@pascal/pascal-core';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { winningStore } from '../../store/winningStore';
import { MobileCombinations } from '../../components/mobileCombinations';
import { Combinations } from '../../components/combinations';

export const CombinationsWrapper = observer(() => {
  const { winCombination, winningAmount } = winningStore;
  const { currencySymbolOrCode } = userInfoStore;
  const t = useTranslation();
  const [showCardsImages, setShowCardsImages] = useState(true);

  if (isMobile()) {
    return (
      <MobileCombinations
        t={t}
        winningAmount={winningAmount}
        winCombination={winCombination}
        showCardsImages={showCardsImages}
        setShowCardsImages={setShowCardsImages}
        currencySymbolOrCode={currencySymbolOrCode}
      />
    );
  }

  return (
    <Combinations
      t={t}
      winCombination={winCombination}
      showCardsImages={showCardsImages}
      setShowCardsImages={setShowCardsImages}
    />
  );
});
